import Services from '../../services';

export default class Service extends Services {
  getResumoIndicadores = async (dataInicial, dataFinal, idEmpresa) => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const url = `${this.endPoint}Graficos/dadoResumoIndicadores/${dataInicial}/${dataFinal}/${idEmpresa}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'application/json',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };

  listCompany = async () => {
    const tokenLogin = localStorage.getItem('token');
    try {
      const response = await fetch(`${this.endPoint}Empresa`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${tokenLogin}`,
          'Content-Type': 'text/plain',
        },
      });

      const json = await response.json();

      return json;
    } catch (err) {
      console.log('Error problem', err);
      this.doLogout()
    }
  };
}
